import _ from "lodash";
import * as type from "./types";
export default (state = {}, action) => {
  switch (action.type) {
    case type.FETCH_PUBLIC_HOLIDAYS:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.FETCH_PUBLIC_HOLIDAY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.CREATE_PUBLIC_HOLIDAY:
      return { ..._.mapKeys(action.payload, "Id") };
    case type.EDIT_PUBLIC_HOLIDAY:
      return { ...state, [action.payload.Id]: action.payload };
    case type.DELETE_PUBLIC_HOLIDAY:
      return _.omit(state, action.payload);
    default:
      return state;
  }
};
